import { Component, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { InvoiceModel } from 'src/app/models/invoicing/invoice.model';
import { ChargeAccountService } from 'src/app/services/others/charge-account.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-copy-charge-account',
  templateUrl: './copy-charge-account.component.html',
  styleUrls: ['./copy-charge-account.component.scss'],
  standalone: false
})
export class CopyChargeAccountComponent {
  bussinessDocumentsTypeId: number = 0;
  chargeAccountModel: InvoiceModel = new InvoiceModel();
  consecutive: number = 0;
  listBussinessDocumentsTypes: CustomListDropdown[] = [];
  suscription: Subscription;

  constructor(private chargeAccountService: ChargeAccountService,
    public config: DynamicDialogConfig,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) {
  }

  async ngOnInit(): Promise<void> {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.chargeAccountModel = inputs.chargeAccountModel;
      this.listBussinessDocumentsTypes = inputs.listBussinessDocumentsTypes;
    });
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async copyChargeAccount() {
    if (this.bussinessDocumentsTypeId == 0 || this.bussinessDocumentsTypeId == null) {
      this.toastHandlerService.showToast('warning', 'Debe seleccionar un tipo de Doc. Comercial válido.', 'Atención');
      return;
    }
    if (this.consecutive == 0 || this.consecutive == null) {
      this.toastHandlerService.showToast('warning', 'Debe ingresar un número de Factura válido.', 'Atención');
      return;
    }
    try {
      const response = await firstValueFrom(this.chargeAccountService.copyChargeAccount(this.chargeAccountModel.invoiceId, this.bussinessDocumentsTypeId, this.consecutive));
      this.toastHandlerService.showToast('success', 'La cuenta de cobro fue copiada exitosamente.');

      const data: ModalObjectType = {};
      data.params = { updateChargeAccount: response };
      this.ref.close(data);
    } catch (error) {
      console.error('Error al copiar la cuenta de cobro.', error);
      this.toastHandlerService.showToast('error', 'Error al copiar la cuenta de cobro.', 'Atención');
    }
  }

  getBussinessDocumentsType(bussinessDocumentsTypeId: number | null) {
    if (bussinessDocumentsTypeId != null && bussinessDocumentsTypeId != 0) {
      this.bussinessDocumentsTypeId = bussinessDocumentsTypeId;
    } else {
      this.bussinessDocumentsTypeId = 0;
    }
  }
}
